import React from "react";
import ReactDOM from "react-dom";
import Numble from "./Numble";

import "./reset.css";

ReactDOM.render(
  <React.StrictMode>
    <Numble />
  </React.StrictMode>,
  document.getElementById("root")
);
